import React from 'react'

export const FertighausIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='81'
      height='84'
      viewBox='0 0 81 84'
      fill='none'>
      <path
        opacity='0.2'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 33.6L27.9993 50.4V84L0 67.2V33.6Z'
        fill='#9297A2'
      />
      <path
        opacity='0.2'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M52.5 0L80.4993 16.8V50.4L52.5 33.6V0Z'
        fill='#9297A2'
      />
      <path
        opacity='0.2'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.6 67.2L40.5993 84L68.6007 67.2L40.5993 50.4L12.6 67.2Z'
        fill='#9297A2'
      />
      <path
        opacity='0.2'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.39999 58.1007V26.3676L33.6 10.5V42.2331L8.39999 58.1007Z'
        fill='#9297A2'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.6 25.2L40.5993 42L68.6007 25.2L40.5993 8.4L12.6 25.2Z'
        fill='#9297A2'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M44.1 77.0007V45.2676L69.3 29.4V61.1331L44.1 77.0007Z'
        fill='#9297A2'
      />
    </svg>
  )
}
